export default __webpack_public_path__ + "images/Zippyy_logo_Orange.svg";